import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FrequencyMode } from '../../models/FrequencyMode';
import jsonData from '../../../assets/i18n/en.json';
@Component({
  selector: 'app-schedule-event-dialog',
  templateUrl: './schedule-event-dialog.component.html',
  styleUrls: ['./schedule-event-dialog.component.scss'],
  standalone: false,
})
export class ScheduleEventDialogComponent implements OnInit {
  /*
 This property is to hold selected frequency Time
 */
  selectedTime: string = '';
  Headers: any;

  /*
 This property is to hold selected frequency Mode
 */
  selectedFrequency: string = '';

  /*
This property is to hold selected frequency Day
*/
  selectedDay: string = '';

  selectedAMorPM :string ='';

  /*
  This property is to hold frequency options
  */
  scheduleFrequencyOptions: any = [
    { name: 'Immediate', value: 'Immediate',checked: false },
    { name: 'Once a day',value: 'Daily', checked: false },
    { name: 'Once a week', value: 'Weekly', checked: false },
  ];

  /*
 This property is to hold time for dropdown
 */
  timeArr: any = [];

  /*
This property is to hold days for dropdown
*/
  dayArr: any = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  globalNotifications:boolean = true;

  /*
 This property is to hold selected frequency
 */
  scheduleCategoryAllEvents: boolean = false;

  scheduleAll:boolean = false;

  /*
This property is flag for save button disable
*/
  disableSave: boolean = true;

  /*
This property is to hold previously selected mode
*/
  existingMode: string = '';

  /*
This property is to hold previously selected time
*/
  existingTime: string = '';

  /*
This property is to hold previously selected day
*/
  existingDay: string = '';

  existingAMorPM: string ='';
  /*
  To manage the checkbox click
   */
  applyAllDirty: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ScheduleEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.Headers = jsonData;
    if(data!=null)
    {
    this.globalNotifications =false;
    this.existingMode = this.data.frequency;
    this.selectedTime = this.data.time;
    this.selectedTime =
      this.data.time != undefined && this.data.time != null
        ? this.data.time?.toString().split(':')[0] +
          ':' +
          this.data.time?.toString().split(':')[1]
        : this.data.time;
    if(this.data.time == undefined && this.data.time == null)
      this.selectedAMorPM = 'AM';
    if(parseInt(this.data.time?.toString().split(':')[0])>=12)
        this.selectedAMorPM = 'PM';
    else
    this.selectedAMorPM = 'AM';
    let index = this.scheduleFrequencyOptions.indexOf(
      this.scheduleFrequencyOptions.find(
        (option: any) => { 
          return option.value == data.frequency}
      )
    );
    
    this.scheduleFrequencyOptions[index].checked = true;
    this.selectedFrequency = this.scheduleFrequencyOptions[index].value;
        }
  }

  ngOnInit(): void {
    this.InitializeTimeArray();
    if(this.data!=null){
    this.disableSave = true;
    this.existingTime =
      this.timeArr.find((f) => f == this.selectedTime) == undefined
        ? ''
        : this.selectedTime;
    var convertedTime = parseInt(this.selectedTime?.split(':')[0])>12 ? (parseInt(this.selectedTime?.split(':')[0])-12).toString() + ':00' : this.selectedTime;
    if(parseInt(convertedTime?.split(':')[0])<10 && this.selectedAMorPM =='PM')
      convertedTime = '0'+convertedTime?.split(':')[0]+':00';
    if(this.selectedTime == '00:00')
      convertedTime = '12:00';
    this.selectedTime =
      this.timeArr.find((f) => f == convertedTime) == undefined
        ? '01:00'
        : convertedTime;
    this.selectedDay =
      this.data.day == undefined || this.data.day == null || this.data.day ==''
        ? this.dayArr[0]
        : this.data.day;
    this.existingTime = this.selectedTime;
    this.existingDay = this.selectedDay;
    this.existingAMorPM = this.selectedAMorPM;
    }
    else
      this.scheduleAll=true;
  }

  InitializeTimeArray() {
    for (let h_index = 1; h_index <=12; h_index++) {
      let hour: string = h_index < 10 ? '0' + h_index : h_index.toString();
      this.timeArr.push(hour + ':' + "00");
    }
  }

  /*
   This method is called when cancel button clicked
   */
  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  /*
  This method is used to check whether save button can be in enable or disable state based on mode selections
  */
  onModeChanged(mode: string) {
    if (!this.checkModeChange(mode) && this.applyAllDirty) {
      this.disableSave = false;
    } else if (this.checkModeChange(mode) || this.selectedAMorPM != this.existingAMorPM || this.selectedTime !== this.existingTime || this.selectedDay !== this.existingDay) {
      this.disableSave = this.isModeChangeValid(mode);
    } else {
      this.disableSave = true;
    }
  }

  onAMorPMChanged(mode:string){
    if(mode == this.existingAMorPM)
    {
      if(this.selectedTime === this.existingTime && this.selectedDay === this.existingDay && this.existingMode === this.selectedFrequency && !this.applyAllDirty)
        this.disableSave = true;
      else
        this.disableSave = false;
    }
    else
      this.disableSave = false;
  }
  /*on selecting a day or time change save button is re enabled.
   */
  onDayTimeChanged() {
    if(this.applyAllDirty)
      this.disableSave = false;
    else
      this.disableSave = this.isModeChangeValid(this.selectedFrequency);
  }
  /*
  This moethod check if mode is modified
   */
  checkModeChange(newMode: string): boolean {
    return this.existingMode !== newMode;
  }
  /*
  This method checks on change of mode is time and day selected
  */
  isModeChangeValid(mode: string): boolean {
    let disable: boolean = true;
    switch (mode) {
      case FrequencyMode.Daily:
        if (this.existingMode === FrequencyMode.Weekly) {
          disable =
            this.selectedTime !== '' &&
            this.selectedTime !== undefined &&
            this.selectedTime !== null;
        } else {
          disable =
            this.selectedTime !== '' &&
            this.selectedTime !== undefined &&
            this.selectedTime !== null && 
            (this.selectedTime !== this.existingTime || this.existingMode !==mode || this.existingAMorPM !== this.selectedAMorPM);
        }
        break;
      case FrequencyMode.Weekly:
        disable =
          this.selectedTime !== '' &&
          this.selectedTime !== undefined &&
          this.selectedTime !== null &&
          this.selectedDay !== '' &&
          this.selectedDay !== undefined &&
          this.selectedDay !== null &&
          this.selectedDay !== 'null' &&
          (this.selectedTime !== this.existingTime ||
            this.existingDay !== this.selectedDay || this.existingMode !==mode || this.existingAMorPM !== this.selectedAMorPM);
        break;
      default:
        disable = true;
        break;
    }
    return !disable;
  }

  isGlobalModeChangeValid(mode = this.selectedFrequency){
    switch(mode){
      case FrequencyMode.Daily:
        this.disableSave = 
          this.selectedTime === '' ||
          this.selectedTime === undefined ||
          this.selectedTime === null ||
          this.selectedAMorPM === '' ||
          this.selectedAMorPM === undefined ||
          this.selectedAMorPM === null;
        break;
      case( FrequencyMode.Weekly):
        this.disableSave = 
          this.selectedTime === '' ||
          this.selectedTime === undefined ||
          this.selectedTime === null ||
          this.selectedAMorPM === '' ||
          this.selectedAMorPM === undefined ||
          this.selectedAMorPM === null ||
          this.selectedDay === '' ||
          this.selectedDay === undefined ||
          this.selectedDay === null ;
        break;
      default:
        this.disableSave = false;
    }
  }
  /*
  This method is called when apply all button clicked
  */
  applyAllChange($event: any) {
    this.applyAllDirty = $event.checked;
    if (this.applyAllDirty && !this.checkModeChange(this.selectedFrequency)) {
      this.disableSave = false;
    } else if (!this.checkModeChange(this.selectedFrequency)) {
      this.disableSave = true;
    }
    this.onDayTimeChanged();
  }
  /*
This method is called when save button clicked
*/
  saveSchedule() {
    if(this.selectedAMorPM == 'PM' && this.selectedTime!='12:00'){
      this.selectedTime = (parseInt(this.selectedTime.split(':')[0]) +12).toString() +':00';
    }
    if(this.selectedTime.split(':')[0] == '12' && this.selectedAMorPM == 'AM')
      this.selectedTime = '00:00';
    let scheduleObj = {
      frequencyTime:
        this.selectedFrequency !== FrequencyMode.Immediate
          ? this.selectedTime
          : '',
      deliveryDay:
        this.selectedFrequency === FrequencyMode.Weekly ? this.selectedDay : '',
      frequencyMode: this.selectedFrequency,
       scheduleCategoryAllEvents: this.scheduleCategoryAllEvents,
    };
    this.dialogRef.close({ data: scheduleObj });
  }
}
